/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as types from '../constants';

export const INITIAL_LOTTERY_STATE = {
    lottery: {
        id: null,
        name: '',
        description: '',
        summary: '',
        instructions: '',
        award_message: '',
        lose_message: '',
        open_at: null,
        close_at: null,
        fee: '',
        refundable: false,
        select_number: 0,
        require_acceptance: true,
        acceptance_window: 0,
        max_entries: 1,
    },
    create_loading: false,
    create_error: '',
    update_loading: false,
    update_error: '',

    open_lotteries: [],
    future_lotteries: [],
    past_lotteries: [],
    lotteries_loading: false,
    lotteries_error: '',
};

export default function lottery(
    state: Partial<typeof INITIAL_LOTTERY_STATE> = INITIAL_LOTTERY_STATE,
    action: {
        payload?: { open: any; future: any; past: any };
        error?: any;
        type?: string;
        data?: any;
    }
) {
    switch (action.type) {
        case types.FETCH_LOTTERIES_SUCCESS:
            return {
                ...state,
                open_lotteries: action.payload?.open,
                future_lotteries: action.payload?.future,
                past_lotteries: action.payload?.past,
                lotteries_error: '',
                lotteries_loading: false,
            };
        case types.FETCH_LOTTERIES_ERROR:
            return { ...state, lotteries_error: action.error, lotteries_loading: false };
        case types.FETCH_LOTTERIES_START:
            return {
                ...state,
                open_lotteries: [],
                future_lotteries: [],
                past_lotteries: [],
                lotteries_error: '',
                lotteries_loading: true,
            };

        case types.NEW_LOTTERY:
            return { ...state, ...INITIAL_LOTTERY_STATE };

        case types.FETCH_LOTTERY_SUCCESS:
            return {
                ...state,
                lottery: action.payload,
                update_error: '',
                create_error: '',
            };

        case types.FETCH_LOTTERY_STATISTICS_SUCCESS:
            return {
                ...state,
                lotteryStatistics: action.payload,
                lotteryStatisticsError: '',
            };

        case types.FETCH_LOTTERY_STATISTICS_ERROR:
            return { ...state, lotteryStatisticsError: action.data };

        case types.FETCH_LOTTERY_STATISTICS_LOADING:
            return {
                ...state,
                lotteryStatisticsLoading: action.payload,
            };

        case types.CREATE_LOTTERY_START:
            return { ...state, create_loading: true };

        case types.CREATE_LOTTERY_SUCCESS:
            return {
                ...state,
                lottery: action.data,
                create_loading: false,
                create_error: '',
            };

        case types.CREATE_LOTTERY_ERROR:
            return { ...state, create_loading: false, create_error: action.data };

        case types.UPDATE_LOTTERY_START:
            return { ...state, update_loading: true };

        case types.UPDATE_LOTTERY_SUCCESS:
            return {
                ...state,
                lottery: action.data,
                update_loading: false,
                update_error: '',
            };

        case types.UPDATE_LOTTERY_ERROR:
            return { ...state, update_loading: false, update_error: action.data };

        default:
            return state;
    }
}
